import React from "react";
import {IReportEvaluationContext} from "../models/ReportEvaluationModels";
import {DEFAULT_EVALUATION_REPORT_CONTEXT} from "../constants/reportDetailModal";

export const ReportEvaluationContext = React.createContext<IReportEvaluationContext>(DEFAULT_EVALUATION_REPORT_CONTEXT);

export const ReportEvaluationProvider = ReportEvaluationContext.Provider;

export const useReportEvaluationContext = () => React.useContext(ReportEvaluationContext);
